import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-protocol-permission-letter',
  templateUrl: './protocol-permission-letter.component.html',
  styleUrls: ['./protocol-permission-letter.component.scss']
})
export class ProtocolPermissionLetterComponent implements OnInit {
  public files: File[] = [];
  public isUploading = false;
  public uploadSuccess = false;
  public uploadError = '';
  public maxFiles = 5;
  public maxFileSize = 20 * 1024 * 1024; // 20MB

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
  }

  onFileSelect(event: any): void {
    const selectedFiles = event.target.files;
    const newFiles: File[] = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];
      
      // Check if file is PDF
      if (file.type !== 'application/pdf') {
        console.error('Only PDF files are allowed');
        alert('Only PDF files are allowed');
        event.target.value = '';
        return;
      }

      // Check file size
      if (file.size > this.maxFileSize) {
        console.error('File size must be less than 20MB');
        alert('File size must be less than 20MB');
        event.target.value = '';
        return;
      }

      newFiles.push(file);
    }

    // Check total files limit
    if (this.files.length + newFiles.length > this.maxFiles) {
      console.error(`Maximum ${this.maxFiles} files allowed`);
      alert(`Maximum ${this.maxFiles} files allowed`);
      event.target.value = '';
      return;
    }

    this.files = this.files.concat(newFiles);
    event.target.value = '';
  }

  removeFile(index: number): void {
    this.files.splice(index, 1);
  }

  uploadFiles(): void {
    if (this.files.length === 0) {
      console.error('Please select at least one PDF file');
      alert('Please select at least one PDF file');
      return;
    }

    this.isUploading = true;
    this.uploadError = '';

    const formData = new FormData();
    
    // Append all files with the same key 'file'
    this.files.forEach((file) => {
      formData.append('file', file);
    });

    

    this.apiService.uploadProtocolPermissionLetter(formData).subscribe(
      (res: any) => {
        this.isUploading = false;
        if (res.success) {
          this.uploadSuccess = true;
          console.log('Success:', res.message);
          setTimeout(() => {
            this.activeModal.close('success');
          }, 1500);
        }
      },
      (err) => {
        this.isUploading = false;
        console.log(err);
        const errorMessage = (err.error && err.error.message) ? err.error.message : 'Failed to upload files';
        this.uploadError = errorMessage;
        console.error('Upload error:', errorMessage);
      }
    );
  }

  closeModal(): void {
    this.activeModal.close('');
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
